// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".main-account-wedding-list-create{background:#dff2f0}", "",{"version":3,"sources":["webpack://./resources/js/pages/Account/Wishlist/WeddingListCreate.vue"],"names":[],"mappings":"AACA,kCACI,kBAAJ","sourcesContent":["\n::v-global(.main-account-wedding-list-create) {\n    background: #dff2f0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
